export default __webpack_public_path__ + "static/lausd-logo-1f8f734dd6c7279c86d5ef8838755e20.png";